/**
 * Flags a patient phone number the server would refuse - `patient-phone-number="mobile"` or
 * `patient-phone-number="landline"` on the input. The ngModel error is `invalidPhoneNumber`, so the form
 * will not submit it and auto-validate puts the message under the field. What each field accepts, and
 * why, is in PhoneNumberService.js.
 */
app.directive("patientPhoneNumber", ["PhoneNumber", function (PhoneNumber) {
	return {
		restrict: "A",
		require: "ngModel",
		link: function (scope, element, attrs, ngModel) {
			ngModel.$validators.invalidPhoneNumber = function (value) {
				if (value === null || value === undefined || value === "") {
					return true; // "required" says whether it may be empty
				}
				return attrs.patientPhoneNumber === "landline" ? PhoneNumber.isValidLandline(value) : PhoneNumber.isValidMobile(value);
			};
		},
	};
}]);
